import React from 'react'
import { Link } from 'react-router-dom'
import type { UpgradeListSummary } from '../../features/recipe-upgrades/list-types'
import { recipeUpgradeListCopy } from '../../features/recipe-upgrades/list-copy'

export const RecipeUpgradeBanner = ({
    summary,
    enabled = true,
}: {
    summary: UpgradeListSummary | null
    enabled?: boolean
}) => {
    if (!enabled || !summary || summary.not_upgraded === 0) {
        return null
    }

    const total = summary.not_upgraded + (summary.upgraded ?? 0)
    const daysAway = Math.ceil(
        (Date.parse(`${summary.deadline}T00:00:00Z`) - Date.now()) / 86_400_000,
    )
    return (
        <div
            className="m-4 flex items-center gap-[14px] rounded-lg border border-[#E5E7EB] bg-white px-[18px] py-4 shadow-[0_1px_2px_rgba(17,20,24,.04)]"
            data-testid="recipe-upgrade-banner"
        >
            <div className="flex-1 text-[14px] leading-[21px] text-[#1C2127]">
                <div className="font-semibold tracking-[-0.005em]">
                    {recipeUpgradeListCopy.bannerTitle}
                </div>
                {daysAway >= 0 && daysAway <= 7 && <div>That is {daysAway} days away.</div>}
                <div>
                    {summary.upgraded
                        ? recipeUpgradeListCopy.bannerBodyPartWay(summary.not_upgraded, total)
                        : recipeUpgradeListCopy.bannerBody(summary.not_upgraded)}
                </div>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
                <Link
                    className="inline-flex h-[30px] items-center rounded-lg px-[10px] py-[5px] text-[14px] leading-5 text-[#215db0]"
                    to="/recipes/upgrade-to-segments"
                >
                    {recipeUpgradeListCopy.viewChanges}
                </Link>
                <Link
                    className="inline-flex h-[30px] items-center rounded-lg bg-[#2d72d2] px-3 py-[5px] text-[14px] leading-5 text-white shadow-[0_2px_4px_rgba(0,0,0,.075)]"
                    to="/recipes/upgrade-to-segments"
                >
                    {recipeUpgradeListCopy.upgradeAll(summary.not_upgraded)}
                </Link>
            </div>
        </div>
    )
}
